import { render } from "./portofolio.vue?vue&type=template&id=486f0569&scoped=true"
import script from "./portofolio.vue?vue&type=script&lang=js"
export * from "./portofolio.vue?vue&type=script&lang=js"

import "./portofolio.vue?vue&type=style&index=0&id=486f0569&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\zoinix-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486f0569"]])

export default __exports__